import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import { report } from './reportError'
import { getDomain, CUSTOME_TRACE_ID } from './utils'
import HandleError from './handleError'
//让ajax携带cookie
const $ajax= axios.create({
  withCredentials:true,
  // headers: {'X-Custom-Trace': uuidv4()} //此处需要改nginx，否则请求报错，暂时不加，改变方案先在请求入參上加参数
});
$ajax.interceptors.request.use(config => {
  const url = config.url
  // if (!url.includes('/popAuthLogin/login4NewPortal.do')) {
    if (url.includes('?')) {
      config.url = `${url}&${CUSTOME_TRACE_ID}=${uuidv4()}`
    } else {
      config.url = `${url}?${CUSTOME_TRACE_ID}=${uuidv4()}`
    }
  // }

  return config;
}, error => {
  return Promise.reject(error);
});

// Add a response interceptor
$ajax.interceptors.response.use(response => {
  const traceId = response.headers['x-trace-id'] || ''
  const url = response.config.url
  const requestDomain = getDomain(url)
  if (requestDomain && HandleError[requestDomain]) {
    return HandleError[requestDomain].handle(url, response)
  }
  const rs = response && response.data ? response.data : response
  if (rs) {
    return rs
  } else {
    report({
      config: response.config,
      res: response,
      traceId,
      msg: '接口请求返回为空'
    })
    return {}
  }
}, error => {
  console.log(error.response)
  const config = error.config || {}
  report({
    error,
    msg: error.message || '接口请求错误',
    config
  })
  return {
    report: true,
    msg: error.message
  };
});

const ajax= axios.create();
ajax.interceptors.request.use(config => {
  const url = config.url
  if (url.includes('?')) {
    config.url = `${url}&${CUSTOME_TRACE_ID}=${uuidv4()}`
  } else {
    config.url = `${url}?${CUSTOME_TRACE_ID}=${uuidv4()}`
  }
  return config;
}, error => {
  return Promise.reject(error);
});
ajax.interceptors.response.use(response => {
  const traceId = response.headers['x-trace-id'] || ''
  const url = response.config.url
  const requestDomain = getDomain(url)
  if (requestDomain && HandleError[requestDomain]) {
    return HandleError[requestDomain].handle(url, response)
  }
  const rs = response && response.data ? response.data : response
  if (rs) {
    return rs
  } else {
    report({
      config: response.config,
      res: response,
      traceId,
      msg: '接口请求返回为空'
    })
    return {}
  }
}, error => {
  console.log(error.response)
  const config = error.config || {}
  report({
    config,
    error,
    msg: error.message || '接口请求错误'
  })
  return {
    report: true,
    msg: error.message
  };
});

export const $http = $ajax;//拦截款1 :拦截登录
export const http = ajax;//拦截款2  :不拦截登录
